import React from 'react';

/**
 * Standard page heading: optional eyebrow (division or section), title,
 * optional subtitle, and right-aligned actions.
 */
export default function PageHeader({ eyebrow, title, sub, actions }) {
  return (
    <div className="page-head">
      <div className="page-head-text">
        {eyebrow && <div className="page-eyebrow">{eyebrow}</div>}
        <h1 className="page-title">{title}</h1>
        {sub && <p className="page-sub">{sub}</p>}
      </div>
      {actions && <div className="page-actions">{actions}</div>}
    </div>
  );
}
